module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0vii-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "para5"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("“Guess now who holds thee?”—"), _c('br'), _vm._v("“Death,” I said. But there"), _c('br'), _vm._v(" The silver answer rang—"), _c('br'), _vm._v("“Not Death, but Love.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "right-para5"
  }, [_vm._v("—Elizabeth Barrett Browning,")]), _vm._v(" "), _c('p', {
    staticClass: "right-para5a"
  }, [_c('em', [_vm._v("Sonnets from the Portuguese")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2714bc8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/map.vue
// module id = 72
// module chunks = 0